import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LevelChangerThing } from "./levelChangerThing";

export class Downstairs extends LevelChangerThing {
	static key = "Downstairs";
	constructor(xy: XY, destinationLevel: number) {
		super(xy, destinationLevel);
	}

	static initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const stairs = new Downstairs(xy, (props?.destination as number) ?? 0);
		board.putThing(stairs);
		return [stairs];
	}

	static deserialize(data: any): Downstairs {
		const d = new Downstairs(deserializeXY(data.xy), data.destinationLevel);
		d.visualId = data.visualId;
		return d;
	}
}
